var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      dialog: _vm.show,
      title: _vm.view
        ? _vm.$t(
            "label_essweb_shiftTypeMapping_dialog_viewShiftTypeMappingTitle"
          )
        : _vm.$t(
            "label_essweb_shiftTypeMapping_dialog_editShiftTypeMappingTitle"
          ),
      width: "680",
      maxWidth: "680",
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form" },
              [
                _c(
                  "v-col",
                  {
                    attrs: {
                      xs: "12",
                      sm: "12",
                      md: "12",
                      lg: "12",
                      cols: "12",
                    },
                  },
                  [
                    _c("AutoComplete", {
                      attrs: {
                        isRequired: "",
                        items: _vm.selectStaff,
                        label:
                          "label_essweb_shiftTypeMapping_dialog_staffNameLabel",
                        "item-text": "preferred_name",
                        "item-value": "uuid",
                        "append-icon": !_vm.view ? "arrow_drop_down" : "",
                        disabled: "",
                        avatar: "",
                        readonly: "",
                        chips: "",
                        "two-line": "",
                        filled: !_vm.view,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "selection.avatar",
                          fn: function (ref) {
                            var data = ref.data
                            return [
                              _c("StaffAvatar", {
                                attrs: {
                                  size: "36",
                                  src: data.item.staff_avatar,
                                  left: "",
                                  staff_name: data.item.preferred_name,
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "selection",
                          fn: function (ref) {
                            var data = ref.data
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$getCommonLangValue(
                                      data.item.preferred_name
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.curuuid,
                        callback: function ($$v) {
                          _vm.curuuid = $$v
                        },
                        expression: "curuuid",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    attrs: {
                      xs: "12",
                      sm: "12",
                      md: "12",
                      lg: "12",
                      cols: "12",
                    },
                  },
                  [
                    _c("AutoComplete", {
                      attrs: {
                        isRequired: "",
                        items: _vm.ShiftTypeList,
                        label:
                          "label_essweb_shiftTypeMapping_dialog_staffTypeLabel",
                        "item-text": "shift_type_name",
                        "item-value": "uuid",
                        "small-chips": "",
                        chips: "",
                        filled: !_vm.view,
                        readonly: _vm.view,
                        "append-icon": !_vm.view ? "arrow_drop_down" : "",
                        "deletable-chips": "",
                        multiple: "",
                        rules: _vm.$GetRules(["_Require_ArrRules"], [null]),
                      },
                      model: {
                        value: _vm.selectType,
                        callback: function ($$v) {
                          _vm.selectType = $$v
                        },
                        expression: "selectType",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            !_vm.view
              ? _c("CardActions", {
                  attrs: { saveBtn: "" },
                  on: { save: _vm.onEdit, cancel: _vm.closeDialog },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }